import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { logout, getAuthUser } from '../auth'

const NAV = [
  { to: '/overview', label: 'Overview', icon: '🏠' },
  { to: '/devices',  label: 'Devices',  icon: '📡' },
  { to: '/alerts',   label: 'Alerts',   icon: '🔔' },
  { to: '/rules',    label: 'Rules',    icon: '📋' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
]

export default function DashboardLayout() {
  const navigate = useNavigate()
  const user = getAuthUser()

  function handleLogout() {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-56 bg-white border-r border-gray-100 flex flex-col">
        <div className="px-5 py-5 border-b border-gray-100">
          <span className="text-base font-semibold text-gray-900">IoT Watchdog</span>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-brand-50 text-brand-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <span className="text-base leading-none">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-4 py-4 border-t border-gray-100">
          <div className="text-xs text-gray-400 mb-2">
            {user?.role} · tenant {user?.tenantId}
          </div>
          <button
            onClick={handleLogout}
            className="text-xs text-gray-500 hover:text-red-600 transition-colors"
          >
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  )
}
